export default "__VITE_ASSET__CUiUhy3h__";